
export const setAllTasks =  (step)=>{
  return { type: 'SET_ALL_DATA' , payload: step};
};

export const setTaskData =  (step)=>{
  return { type: 'SET_DATA' , payload: step};
};

export const setTaskStatus =  (step)=>{
  return { type: 'SET_STATUS' , payload: step};
};

export const setActions =  (action)=>{
  return { type: 'SET_ACTION' , payload: action};
};

export const getTariff =  (action)=>{
  return { type: 'SET_TARIFF' , payload: action};
};

export const setInvoice =  (action)=>{
  return { type: 'SET_INVOICE' , payload: action};
};
